import Vue from 'vue'
import { createClient } from 'contentful'
import RichTextRenderer from 'contentful-rich-text-vue-renderer'

const config = {
  space: process.env.VUE_APP_CTF_SPACE_ID,
  accessToken: process.env.VUE_APP_CTF_CDA_ACCESS_TOKEN,
}

Vue.prototype.$contentful = createClient(config)
Vue.component('RichTextRenderer', RichTextRenderer)
